import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/root/project/task/styles.scss';export default {
  "list": "_list_1n5ue_1",
  "main": "_main_1n5ue_6",
  "highlighted": "_highlighted_1n5ue_14",
  "header": "_header_1n5ue_20",
  "iconBox": "_iconBox_1n5ue_31",
  "icon": "_icon_1n5ue_31",
  "openedIcon": "_openedIcon_1n5ue_47",
  "row": "_row_1n5ue_51",
  "avatar": "_avatar_1n5ue_58",
  "col": "_col_1n5ue_63",
  "name": "_name_1n5ue_72",
  "profession": "_profession_1n5ue_81",
  "recordList": "_recordList_1n5ue_86",
  "noAllocationBadge": "_noAllocationBadge_1n5ue_90",
  "removedBadge": "_removedBadge_1n5ue_103"
};